interface Feature {
    [key: string]: Feature | { enabled: boolean };
}

type FeatureProperty = Record<string, 'true' | 'false'>;

export function getFeaturesProperties(features: Feature): FeatureProperty {
    const result: FeatureProperty = {};

    function visit(value: unknown, path: string[] = []): void {
        if (value === true || value === false) {
            path.pop();

            result[`$feature/${path.join('.')}`] = value ? 'true' : 'false';
            return;
        }

        if (value instanceof Object) {
            Object.entries(value).forEach(([key, entry]) => {
                visit(entry, [...path, key]);
            });
        }
    }

    visit(features);
    return result;
}
